export function extractDate(datetimeStr: string): string {
  const date = new Date(datetimeStr);
  const year = date.getFullYear().toString();
  // getMonth() returns 0-11; adding 1 to get 1-12 and padding with '0' to ensure two digits
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  // getDate() returns 1-31; padding with '0' to ensure two digits
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
}
